// This must use the node CommonJS syntax to be supported on serverless

const data = require('../../app-version.json')

exports.default = data.version
